import React, { useState } from "react";
import LoaderForImage from "../../LoaderForImage";
import upploadImage from "../../../assets/images/upload-video.png";
import { toastService } from "../../../utils/toastify";
import { imageUpload } from "../../../features/slices/liveStream";
import { useDispatch } from "react-redux";
import { addPrize } from "../../../features/slices/challanges";
import { useNavigate } from "react-router-dom";
const initialState = {
  name: "",
  prizeNo: "",
  description: "",
  image: "",
};
const AddPrize = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [imageLoader, setImageLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { name, prizeNo, description, image } = iState;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImage = (e) => {
    setErrors((prev) => ({
      ...prev,
      [e?.target?.name]: "",
    }));
    const file = e.target.files[0];
    setImageLoader(true);
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setUpdateState({
            ...iState,
            [e.target.name]: res?.payload?.url,
          });
          setImageLoader(false);
        } else {
          toastService.error("Failed to upload");
          setImageLoader(false);
        }
      });
    }
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;
    if (!name?.trim()) {
      formErrors.name = "Prize Name is required.";
      isValid = false;
    }
    if (!prizeNo?.trim()) {
      formErrors.prizeNo = "Prize No. is required.";
      isValid = false;
    }
    if (!description?.trim()) {
      formErrors.description = "description is required.";
      isValid = false;
    }
    if (!image?.trim()) {
      formErrors.image = "image is required.";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      // handle form submission
      dispatch(addPrize(iState)).then((res) => {
        console.log({ res });

        if (res?.payload?.code == 200) {
          toastService.success("Prize added successfully");
          setUpdateState(initialState);
          navigate("/challenges/viewPrizeDetails");
        } else {
          toastService.error("Failed to add prize");
        }
      });
    }
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Add New Prize</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Prize Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize Name"
                name="name"
                value={name}
                onChange={handleChange}
              />
              {errors.name && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.name}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Prize No.</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize No."
                name="prizeNo"
                value={prizeNo}
                onChange={handleChange}
              />
              {errors.prizeNo && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.prizeNo}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Prize Description</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Prize Description"
                name="description"
                value={description}
                onChange={handleChange}
              />
              {errors.description && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.description}
                </p>
              )}
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload image</h4>
          </div>
          <div className="CommonForm">
            {imageLoader ? (
              <LoaderForImage />
            ) : (
              <div>
                <div
                  className="UploadBox Image"
                  style={{
                    position: "relative",
                    zIndex: 0,
                  }}
                >
                  <span>
                    {!image && <img src={upploadImage} />}
                    {image && (
                      <>
                        <img
                          src={image}
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                          }}
                        />
                        <i
                          className="fas fa-edit"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            color: "#fff",
                            background: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "50%",
                            padding: "5px",
                            zIndex: 2, // Place icon above the video
                            cursor: "pointer",
                          }}
                          // Trigger file input on icon click
                        />
                      </>
                    )}
                  </span>
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    name="image"
                    onChange={handleImage}
                  />
                  <p>
                    <label>Upload image Image</label> <br /> or drag &amp; drop
                  </p>
                </div>
                {errors.image && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.image}
                  </p>
                )}
              </div>
            )}
          </div>
          <button className="Button" onClick={handleSubmit}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPrize;
